import laroute from '@laroute';
import storage from '@shared/js/storage';

class TrackingService {
	constructor() {
		this.isLocalEnvironment = import.meta.env.DEV;
	}

	trackEvent(eventId, type) {
		try {
			const path = laroute.route('api.event.track', {
				eventId:  eventId,
				type:     type,
				viewerId: storage.viewerId,
			});

			fetch(path, {
				method: 'POST',
			}).catch((error) => {
				console.error('Error tracking event', error);
			});

			if (this.isLocalEnvironment) {
				console.log('[debug]TrackingService:trackEvent ' + eventId + ' ' + type);
			}
		} catch (error) {
			console.error('Error tracking event', error);
		}
	}
}

export default TrackingService;
